import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { DataQuery } from '../../models/data-query.model';
import { DataQueryService } from '../../data-query.service';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-view-query-properties-dialog',
    templateUrl: './view-query-properties-dialog.component.html',
    styleUrls: ['./view-query-properties-dialog.component.css']
})
export class ViewQueryPropertiesDialogComponent implements OnInit, OnDestroy {

    // Properties
    currentQuery: DataQuery;
    subscriptions: Subscription[] = [];

    // Class Functions
    constructor(
        private dialogBox: MatDialogRef<ViewQueryPropertiesDialogComponent>,
        private dataQueryService: DataQueryService
    ) { }

    // Event Functions
    ngOnInit() {
        // POST: syncs the current query
        this.subscriptions.push(
            this.dataQueryService.observableCurrentQueryStream$.subscribe(currentQuery => {
                this.currentQuery = currentQuery;
            })
        );
    }

    ngOnDestroy() {
        // POST: unsubscribes to all subscriptions
        this.subscriptions.forEach(subscription => {
            subscription.unsubscribe();
        });
    }

    close() {
        // PRE: the close button is clicked
        // POST: closes the dialog box
        this.dialogBox.close();
    }

    // Methods
}
